// Cliente del backend turnero: `/turnerowebservice/*`. Este es el default
// que se importa como `axios` en el resto del codigo. Cualquier otra API
// tiene su propio archivo en `src/config/` con su instance dedicada.
import { configure } from 'axios-hooks';
import Axios from 'axios';
import { attachErrorInterceptor } from './errorInterceptor';
import { isPresentableError } from '../shared/utils/apiError';

const baseURL = process.env.REACT_APP_API_URL || '/turnerowebservice';

const axios = Axios.create({
  baseURL,
});

// Dejamos pasar los wrappers que el user tiene que ver: `solucionable: true`
// o System.Exception con mensaje JSON-encoded (comillado) — ver apiError.ts.
// Los 500 genericos ("Object reference..."), 400s y proxy timeouts caen al
// fallback.
attachErrorInterceptor(axios, isPresentableError);

configure({ axios });

export default axios;
